import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Card, CardHeader, CardBody } from 'reactstrap';
import { connect } from "react-redux";
import AppContext from '../../AppContext';
import EnhancedTable from '../../components/dataTableDirectory';
import { SET_FILTER } from '../../actions/actiontypes'
class Directory extends Component {
    constructor() {
        super();
        this.state = {
            state: null,
            page: 1,
            char: ''
        };

    }
    componentDidMount() {
        const page = this.props.match.params.page || 1;
        const char = this.props.match.params.char || '1';
        this.filterByChar(char, page)
    }


    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.page != nextProps.match.params.page) {
            const page = this.props.match.params.page || 1;
            const char = this.props.match.params.char || '1';
            this.filterByChar(char, page)
        }
    }
    filterByChar(char, page) {
        let filter = this.props.filter
        filter = char;
        this.setState({ page })
        this.props.setFilter(filter)
    }

    selectCompany = (company, id) => {
        this.props.history.push(`/company/${company}`);
    }
    render() {
        const { totalCount, context } = this.props
        const YYYY = new Date().getFullYear();
        const title = 'Growjo - The Fastest Growing Companies in 2023';
        const desc = `Indexing and predicting the world’s fastest growing companies in ${YYYY} in terms of number of employees, estimated revenue, etc`;
        const navBaseUrl = `/directory/${this.props.match.params.char || '1'}`;
        const navUrl = `/directory/${this.props.match.params.char || '1'}-`;
        const char = this.props.match.params.char || '1'
        return (
            <div className="animated fadeIn" style={{ height: "100%" }}>
                <Helmet>
                    <title>{title}</title>
                    <meta name="description" content={desc} />
                    <meta name="author" content="Growjo" />
                </Helmet >

                <Card style={{ height: '100%', marginBottom: 0 }}>
                    <CardHeader style={{ backgroundColor: 'white' }}>
                    </CardHeader>
                    <CardBody>
                        <h1>Directory</h1>

                        <div className="chars-wrapper">
                            <a href="/directory/1" className="char">#</a>
                            <a href="/directory/A" className="char">A</a>
                            <a href="/directory/B" className="char">B</a>
                            <a href="/directory/C" className="char">C</a>
                            <a href="/directory/D" className="char">D</a>
                            <a href="/directory/E" className="char">E</a>
                            <a href="/directory/F" className="char">F</a>
                            <a href="/directory/G" className="char">G</a>
                            <a href="/directory/H" className="char">H</a>
                            <a href="/directory/I" className="char">I</a>
                            <a href="/directory/J" className="char">J</a>
                            <a href="/directory/K" className="char">K</a>
                            <a href="/directory/L" className="char">L</a>
                            <a href="/directory/M" className="char">M</a>
                            <a href="/directory/N" className="char">N</a>
                            <a href="/directory/O" className="char">O</a>
                            <a href="/directory/P" className="char">P</a>
                            <a href="/directory/Q" className="char">Q</a>
                            <a href="/directory/R" className="char">R</a>
                            <a href="/directory/S" className="char">S</a>
                            <a href="/directory/T" className="char">T</a>
                            <a href="/directory/U" className="char">U</a>
                            <a href="/directory/V" className="char">V</a>
                            <a href="/directory/W" className="char">W</a>
                            <a href="/directory/X" className="char">X</a>
                            <a href="/directory/Y" className="char">Y</a>
                            <a href="/directory/Z" className="char">Z</a>

                        </div>

                        <EnhancedTable char={char} tableData={context} fullReload={true} navBaseUrl={navBaseUrl} navUrl={navUrl} onSelectCompany={this.selectCompany} page={this.state.page} />
                    </CardBody>
                </Card>
            </div >
        )

    }
}

const mapStateToProps = state => ({
    filter: state.filter.data,
    totalCount: state.filter.totalCount,
    auth: state.auth
})
const mapDispatchToProps = dispatch => ({
    setFilter: filter => dispatch({ type: SET_FILTER, payload: filter }),
})

const ConnectedDirectory = connect(mapStateToProps, mapDispatchToProps)(Directory)

class DirectoryWrapper extends React.Component {
    render() {
        return (
            <ConnectedDirectory context={this.context || {}} {...this.props} />
        )
    }
}
DirectoryWrapper.contextType = AppContext;
export default DirectoryWrapper;




// WEBPACK FOOTER //
// ./client/src/views/directory/index.js